export default __webpack_public_path__ + "static/media/avaliacao-genetica.f401d1de.svg";